/* Dialog Text */
import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import { SubPeriodTypes } from "../../../api/models";

export interface EditSubscriptionDialogData {
  dialogTitle: string;
  isNew: boolean;
  subscriptionName: string;
  subscriptionLevel: string;
  periodTypeId: number;
  subscriptionType: string;
  createdDate: Date;
  expirationDate: Date;
  autoRenew: boolean;
  maxAdminUsers: number;
  maxDesignerUsers: number;
  maxDashboardUsers: number;
  maxReportUsers: number;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  taxExemptId: string;
  taxExemptExpireDate: Date;
  allPeriodTypes: SubPeriodTypes[];
  organizationName?: string;
  purchaserFirstName?: string;
  purchaserLastName?: string;
  purchaserTitle?: string;
  purchaserEmail?: string;
  purchaserPhone?: string;
}

@Component({
  selector: "edit-subscription-dialog",
  styleUrls: ["edit-subscription-dialog.component.css"],
  templateUrl: "./edit-subscription-dialog.component.html",
})
export class EditSubscriptionDialogComponent {
  public Result: DialogResult;

  constructor(
    public dialogRef: MatDialogRef<EditSubscriptionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditSubscriptionDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }
}

/* Calling Methods */
/*
  callEditSubscription(params: EditSubscriptionDialogData) {
    var dialogRef = this.dialog.open(EditSubscriptionDialogComponent, {
      width: '500px',
      data: params
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result != null && result.ResultType != null && result.ResultType == DialogResultType.Ok) {
        //Do something here!
      }
    });
  }
*/
